import React from "react";
import WbSunnyIcon from "@material-ui/icons/WbSunny";
import NightsStayIcon from "@material-ui/icons/NightsStay";

interface IconProps {
  fontSize?: number;
}

export const SunIcon: React.FC<IconProps> = ({ fontSize = 10 }) => (
  <WbSunnyIcon style={{ fontSize, color: "#f5a623" }} />
);

export const MoonIcon: React.FC<IconProps> = ({ fontSize = 10 }) => (
  <NightsStayIcon style={{ fontSize, color: "#7b8fa1" }} />
);
